/**
 * r2Client.js — tutte le operazioni R2 passano dalla edge function r2-proxy.
 * Le credenziali R2 non sono mai nel frontend.
 */
import { supabase } from './supabaseClient'

const invoke = async (action, payload = {}) => {
  const { data, error } = await supabase.functions.invoke('r2-proxy', {
    body: { action, ...payload },
  })
  if (error) throw new Error(error.message)
  if (data?.error) throw new Error(data.error)
  return data
}

/**
 * Upload di un file su R2 con progress tracking.
 * 1. Chiede un presigned PUT URL alla edge function (autenticata)
 * 2. Carica il file direttamente su R2 via XHR (progress nativo)
 */
export const uploadFile = async (key, file, onProgress) => {
  const { url } = await invoke('presign-put', {
    key,
    contentType: file.type || 'application/octet-stream',
  })

  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest()
    if (onProgress) {
      xhr.upload.addEventListener('progress', (e) => {
        if (e.lengthComputable) onProgress(Math.round((e.loaded / e.total) * 100))
      })
    }
    xhr.addEventListener('load', () => {
      if (xhr.status >= 200 && xhr.status < 300) resolve()
      else reject(new Error(`Upload fallito: HTTP ${xhr.status}`))
    })
    xhr.addEventListener('error', () => reject(new Error('Errore di rete durante l\'upload')))
    xhr.addEventListener('abort', () => reject(new Error('Upload annullato')))
    xhr.open('PUT', url)
    xhr.setRequestHeader('Content-Type', file.type || 'application/octet-stream')
    xhr.send(file)
  })
}

/**
 * URL firmato per download (valido 1 ora).
 * Per pagine pubbliche (RevisionePubblica) passare { revisione_token }.
 */
export const getDownloadUrl = async (key, opts = {}) => {
  const { url } = await invoke('presign-get', { key, ...opts })
  return url
}

/** Elimina un file da R2. */
export const deleteFile = (key) => invoke('delete', { key })

// listFiles non esposto — usa direttamente la tabella file_uploads su Supabase.
